import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-line', 'IconBrandLine', [
  [
    'path',
    {
      d: 'M21 10.663c0 -4.224 -4.041 -7.663 -9 -7.663s-9 3.439 -9 7.663c0 3.783 3.201 6.958 7.527 7.56c1.053 .239 .932 .644 .696 2.133c-.039 .238 -.184 .932 .777 .512c.96 -.42 5.18 -3.201 7.073 -5.48c1.304 -1.504 1.927 -3.029 1.927 -4.715v-.01z',
      key: 'svg-0',
    },
  ],
]);
